var _rect, _rect2, _path, _circle, _path2, _path3, _path4, _rect3, _g, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsubscribedContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UnsubcribedMessage_32Px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1229",
    "data-name": "Rectangle 1229",
    width: 30,
    height: 30,
    transform: "translate(1 1)",
    fill: "#fff",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M21.81,5.29a2.784,2.784,0,0,1,.06.58",
    fill: "#165cf3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(16.79 4.44)",
    fill: "#5fbdb0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    d: "M19.43,4.95h2.55a2.279,2.279,0,0,1,2.28,2.28v6.84",
    fill: "none",
    stroke: "#5fbdb0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585-2",
    d: "M17.43,22.88H3.75A2.279,2.279,0,0,1,1.47,20.6V7.23A2.279,2.279,0,0,1,3.75,4.95H15.6",
    fill: "none",
    stroke: "#5fbdb0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    d: "M24.27,7.12l-11.2,7.83L1.87,7.12",
    fill: "none",
    stroke: "#5fbdb0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    width: 14.17,
    height: 14.21,
    transform: "translate(15.84 13.37)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    d: "M24.17,13.86a6.84,6.84,0,1,1-6.84,6.84,6.837,6.837,0,0,1,6.84-6.84h0",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    cx: 6.04,
    cy: 6.04,
    r: 6.04,
    transform: "translate(18.13 14.66)",
    fill: "none",
    stroke: "#ff7171",
    strokeWidth: 1.5
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_373",
    d: "M21.11,19.91h6.1a.644.644,0,0,1,.59.69h0a.761.761,0,0,1-.59.79h-6.1a.752.752,0,0,1-.59-.79h0A.651.651,0,0,1,21.11,19.91Z",
    fill: "#ff7171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribedContactIcon);
export default __webpack_public_path__ + "static/media/unsubscribed-contact-icon.9f67d9f18d244bfcc778130ff721a795.svg";
export { ForwardRef as ReactComponent };